import * as React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    HeaderWrapper,
    ListElement,
    ListElements,
    Logout,
    MenuItemsWrapper,
    MenuRightArea,
    RightArrowCircleIconWrapper,
} from './Header.styles';
import { observer } from 'mobx-react-lite';
import { Logotype } from './Logotype';
import { NotificationsCentre } from 'src/components/NotificationsCentre/NotificationsCentre';
import { betTickerV2Link, cmsV2Link, dashboardLink, defaultLinks, tradingV2Link } from 'src/components/Header/Links';
import { isMenuItemDisabled, HeaderPropsType } from 'src/components/Header/Header';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { useCommon } from 'src/AppState/Common';
import { Permission } from 'src/AppState/PermissionGrants/PermissionGrants.types';

export const HeaderOld = observer(({ onLogoutRequest }: HeaderPropsType) => {
    const { routerBackoffice, permissionGrantsState } = useAppStateContext();
    const common = useCommon();
    const configState = ConfigState.get(common);

    let linksForView = configState.config.dashboardTab ? [dashboardLink, ...defaultLinks] : defaultLinks;
    const hasBonusEnginePermission = permissionGrantsState.has(Permission.bonusEngineManageBonuses);

    if (configState.config.showBonusEngine === false || hasBonusEnginePermission === false) {
        linksForView = linksForView.filter((link) => link.name !== 'Bonus');
    }

    if (configState.config.redirectToNewBetTickerPage === true) {
        linksForView = linksForView.filter((link) => link.name !== 'Bet Ticker');
        linksForView.push(betTickerV2Link);
    }

    if (configState.config.redirectToNewCMSPage === true) {
        linksForView = linksForView.filter((link) => link.name !== 'CMS');
        linksForView.push(cmsV2Link);
    }

    if (configState.config.redirectToNewTradingPage === true) {
        linksForView = linksForView.filter((link) => link.name !== 'Trading');
        linksForView.push(tradingV2Link);
    }

    const onLogoutClick = (e: React.SyntheticEvent): void => {
        e.preventDefault();
        onLogoutRequest();
    };

    const route = routerBackoffice.getValueString('global');

    const elements = linksForView.map((item) => {
        return (
            <ListElement
                isActive={item.route === `global:${route}`}
                isDisabled={isMenuItemDisabled(item, permissionGrantsState)}
                key={`${item.name}` + `${item.route}`}
                route={item.route}
                parameters={item.parameters}
                dataTest={`list-element-${item.name.toLowerCase().replace(' ', '-')}`}
            >
                {item.name}
            </ListElement>
        );
    });

    return (
        <HeaderWrapper>
            <Logotype />
            <MenuItemsWrapper data-test='menu-items-wrapper'>
                <ListElements>{elements}</ListElements>

                <MenuRightArea>
                    <NotificationsCentre />
                    <Logout
                        onClick={onLogoutClick}
                        data-test='logout-button'
                    >
                        <RightArrowCircleIconWrapper />
                    </Logout>
                </MenuRightArea>
            </MenuItemsWrapper>
        </HeaderWrapper>
    );
});
